import request from '@/utils/request'

let ApartmentApi = {

  /*公寓列表*/
  list(data) {
    return request._post('/shop/plus.apartment.Index/index', data);
},
/*添加公寓*/
add(data) {
    return request._post('/shop/plus.apartment.Index/add', data);
},
/*修改公寓*/
edit(data) {
    return request._post('/shop/plus.apartment.Index/edit', data);
},
/*删除公寓*/
del(data) {
    return request._post('/shop/plus.apartment.Index/del', data);
},
/*公寓详情*/
detail(data) {
  return request._post('/shop/plus.apartment.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.apartment.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.apartment.Setting/getSetting', data, errorback);
    },
}
export default ApartmentApi;



// WEBPACK FOOTER //
// ./src/api/apartment.js